import {
    Box,
    Button,
    CircularProgress,
    Collapse,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import { Autocomplete } from "@material-ui/lab";
import ContinuarSinAdicionales from "./ContinuarSinAdicionales";
import DataTableProv from "../utils/DataTableProv";
import DeleteIcon from "@material-ui/icons/Delete";
import EliminarActividadSecundaria from "./EliminarActividadSecundaria";
import { Fragment } from "react";
import GiroPrincipalAsignar from "./GiroPrincipalAsignar";
import GiroPrincipalEliminar from "./GiroPrincipalEliminar";
import InfoIcon from "@material-ui/icons/Info";
import ProveedoresTitle from "../layout/ProveedoresTitle";
import UndoIcon from "@material-ui/icons/Undo";
import { enumMaxWidth } from "../../settings/enumConfig";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { theme } from "../../settings/themeConfig";
import { useActividadesEconomicas } from "../../context/ActividadesEconomicasContext";
import { useGiroPrincipal } from "../../context/GiroPrincipalContext";

const GiroPrincipal = () => {
    const { lstActividadesEconomicas, lstActividadesCatalogo } = useActividadesEconomicas();

    const {
        lstActividadesSecundariasSeleccionadas,
        actividadSeleccionada,
        actividadPreseleccionada,
        actividadCatalogoSeleccionado,
        handleClickAsignarActividad,
        handleClickEliminarGiro,
        handleClickEliminarActividadSecundaria,
        handleChangeActividadCatalogoSeleccionado,
        handleClickAgregarActividadCatalogo,
        handleClickSiguiente,
        handleClickRegresar,
        handleChangeActividadPreseleccionada,
    } = useGiroPrincipal();

    return (
        <Fragment>
            <Grid container spacing={4} className="content-over">
                <Grid item xs={12}>
                    <Box style={{ borderRadius: "15px", maxWidth: enumMaxWidth, margin: "auto" }}>
                        <Collapse in={actividadSeleccionada.iIdActividadEconomica === 0}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <ProveedoresTitle>GIRO PRINCIPAL</ProveedoresTitle>
                                </Grid>
                                {actividadSeleccionada.iIdActividadEconomica === 0 && (
                                    <Grid item xs={12}>
                                        <Typography>
                                            Establezca su giro principal de acuerdo a lo declarado ante la autoridad tributaria. Para
                                            establecer el giro principal seleccione un grupo, subgrupo y la actividad principal. Despúes de
                                            clic en "Asignar"
                                        </Typography>
                                    </Grid>
                                )}
                                {lstActividadesEconomicas.length === 0 ? (
                                    <Grid item xs={12} className="center">
                                        <CircularProgress />
                                        <Typography>Cargando lista de actividades</Typography>
                                    </Grid>
                                ) : (
                                    <Grid item xs={12}>
                                        <DataTableProv
                                            columns={[
                                                { field: "tool", title: "Tool", hideSort: true, hideFilter: true },
                                                { field: "sDescripcion", title: "Actividad" },
                                                { field: "sSubgrupo", title: "Subgrupo" },
                                                { field: "sGrupo", title: "Grupo" },
                                            ]}
                                            data={lstActividadesEconomicas}
                                            row={actividadPreseleccionada}
                                            setRow={handleChangeActividadPreseleccionada}
                                            id="iIdActividadEconomica"
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Collapse>
                        <Collapse in={actividadSeleccionada.iIdActividadEconomica !== 0}>
                            {actividadSeleccionada.iIdActividadEconomica !== 0 && (
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>GIRO PRINCIPAL</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ flex: 1 }}>
                                                <Typography>
                                                    <strong>GRUPO:</strong>&nbsp;{actividadSeleccionada.sGrupo}
                                                </Typography>
                                                <Typography>
                                                    <strong>SUBGRUPO:</strong>&nbsp;{actividadSeleccionada.sSubgrupo}
                                                </Typography>
                                                <Typography>
                                                    <strong>ACTIVIDAD PRINCIPAL:</strong>&nbsp;{actividadSeleccionada.sDescripcion}
                                                </Typography>
                                            </div>
                                            <Tooltip arrow placement="top" title={actividadSeleccionada.sActividadesIncluye}>
                                                <IconButton>
                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip arrow placement="top" title="Seleccionar otra actividad principal">
                                                <IconButton color="primary" onClick={handleClickEliminarGiro}>
                                                    <UndoIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>ACTIVIDADES ADICIONALES</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography>
                                            Puede seleccionar hasta 4 actividades secundarias. Seleccione el Segmento, Familia, Clase y
                                            Producto, después de clic en "Agregar"
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <Typography variant="h6">SERVICIOS</Typography>
                                            </Grid>
                                            {lstActividadesCatalogo.length === 0 ? (
                                                <Grid item xs={12} className="center">
                                                    <CircularProgress />
                                                    <Typography>Cargando lista de actividades secundarias</Typography>
                                                </Grid>
                                            ) : (
                                                <Grid item xs={12}>
                                                    <div style={{ display: "flex" }}>
                                                        <div style={{ flex: 1 }}>
                                                            <Autocomplete
                                                                options={lstActividadesCatalogo}
                                                                getOptionLabel={(option) => option.sNombreProductoBepensa}
                                                                fullWidth
                                                                value={actividadCatalogoSeleccionado}
                                                                onChange={handleChangeActividadCatalogoSeleccionado}
                                                                // disablePortal={true}
                                                                disabled={lstActividadesSecundariasSeleccionadas.length >= 4}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Buscar nombre o código de producto UNSPSC"
                                                                        variant={inputVariant}
                                                                        color={inputColor}
                                                                    />
                                                                )}
                                                                renderOption={(option, { inputValue }) =>
                                                                    parse(
                                                                        option.sNombreProductoBepensa,
                                                                        match(option.sNombreProductoBepensa, inputValue)
                                                                    ).map((part, index) => (
                                                                        <span key={index} className={part.highlight ? "highlight" : ""}>
                                                                            {part.text}
                                                                        </span>
                                                                    ))
                                                                }
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            style={{ marginLeft: 10 }}
                                                            disabled={
                                                                !actividadCatalogoSeleccionado ||
                                                                lstActividadesSecundariasSeleccionadas.length >= 4
                                                            }
                                                            onClick={handleClickAgregarActividadCatalogo}
                                                        >
                                                            Agregar
                                                        </Button>
                                                    </div>
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <TableContainer component={Paper}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ backgroundColor: theme.palette.primary.main }}>
                                                                <TableCell style={{ color: "white", padding: 15 }}>
                                                                    Actividades adicionales agregadas
                                                                </TableCell>
                                                                <TableCell style={{ width: 100 }}></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {lstActividadesSecundariasSeleccionadas.map((x) => (
                                                                <TableRow key={x.iCommodity}>
                                                                    <TableCell>{x.sNombreProductoBepensa}</TableCell>
                                                                    <TableCell>
                                                                        <Tooltip arrow placement="top" title="Eliminar actividad">
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={() => handleClickEliminarActividadSecundaria(x)}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}

                                                            {lstActividadesSecundariasSeleccionadas.length === 0 && (
                                                                <TableRow>
                                                                    <TableCell colSpan={2} align="center">
                                                                        <Typography color="textSecondary" variant="body2">
                                                                            (No se han seleccionado actividades)
                                                                        </Typography>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                            {/* <Grid item xs={12} style={{ height: 200 }}></Grid> */}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Collapse>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                {actividadSeleccionada.iIdActividadEconomica === 0 ? (
                    <Grid item xs={12} className="form-buttons">
                        <Button variant="contained" color="secondary" onClick={handleClickRegresar}>
                            Regresar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={actividadPreseleccionada.iIdActividadEconomica === 0}
                            onClick={handleClickAsignarActividad}
                            style={{ marginLeft: 10 }}
                        >
                            Asignar giro principal
                        </Button>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <div className="form-buttons">
                            <Button variant="contained" color="secondary" onClick={handleClickRegresar}>
                                Regresar
                            </Button>
                            <Button variant="contained" color="primary" style={{ marginLeft: 10 }} onClick={handleClickSiguiente}>
                                Siguiente
                            </Button>
                        </div>
                    </Grid>
                )}
            </Grid>
            <GiroPrincipalAsignar />
            <GiroPrincipalEliminar />
            <EliminarActividadSecundaria />
            <ContinuarSinAdicionales />
        </Fragment>
    );
};

export default GiroPrincipal;
